module.exports = __webpack_public_path__ + "static/img/14-2-2.1133c78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/01/14-2-2.jpg
// module id = FjO3
// module chunks = 7